export default "__VITE_ASSET__qcnAfgRT__"